// Recent searches, stored per device in localStorage (lizlook:recent-searches, newest first, max 6).
// Terms are remembered when the predictive search form is submitted, a result or "view all" is
// chosen, Enter is pressed in the search input, or a search results page is opened.
// <s-recent-searches data-search-url="/search"> renders them from its <template> and hides when empty.
const KEY = 'lizlook:recent-searches';
const MAX = 6;

function read() {
  try {
    const value = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(value) ? value.filter((term) => typeof term === 'string' && term.trim()) : [];
  } catch {
    return [];
  }
}

function write(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    /* storage unavailable */
  }
  document.dispatchEvent(new CustomEvent('recent-searches:change'));
}

function remember(raw) {
  const term = String(raw || '').trim().replace(/\s+/g, ' ').slice(0, 60);
  if (term.length < 2) return;
  const key = term.toLocaleLowerCase(document.documentElement.lang || 'tr');
  const list = read().filter((item) => item.toLocaleLowerCase(document.documentElement.lang || 'tr') !== key);
  list.unshift(term);
  write(list.slice(0, MAX));
}

class SRecentSearches extends HTMLElement {
  #abort;

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    this.list = this.querySelector('[data-recent-list]');
    this.template = this.querySelector('template');
    this.querySelector('[data-recent-clear]')?.addEventListener('click', () => write([]), { signal });
    document.addEventListener('recent-searches:change', () => this.#render(), { signal });
    this.#render();
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #render() {
    if (!this.list || !this.template) return;
    const terms = read();
    this.hidden = terms.length === 0;
    const base = this.dataset.searchUrl || '/search';
    this.list.replaceChildren(
      ...terms.map((term) => {
        const node = this.template.content.firstElementChild.cloneNode(true);
        const link = node.querySelector('a');
        const url = new URL(base, window.location.origin);
        url.searchParams.set('q', term);
        link.href = url.pathname + url.search;
        node.querySelector('[data-term]').textContent = term;
        return node;
      })
    );
  }
}

if (!customElements.get('s-recent-searches')) {
  customElements.define('s-recent-searches', SRecentSearches);

  const input = () => document.getElementById('predictive-search-input');
  document.addEventListener(
    'submit',
    (event) => {
      if (event.target instanceof HTMLFormElement && event.target.contains(input())) remember(input().value);
    },
    true
  );
  document.addEventListener(
    'click',
    (event) => {
      const chosen = event.target.closest?.('#predictive-search [data-ps-url], #predictive-search [data-fade-overlay] a');
      if (chosen && input()) remember(input().value);
    },
    true
  );
  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'Enter' && event.target === input()) remember(input().value);
    },
    true
  );
  if (/\/search\/?$/.test(window.location.pathname)) {
    remember(new URLSearchParams(window.location.search).get('q'));
  }
}
